import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import TabFieldBlock from "./TabFieldBlock";
var FormGroupTab = function FormGroupTab(props) {
  return /*#__PURE__*/React.createElement(Field, _extends({
    component: TabFieldBlock
  }, props));
};
FormGroupTab.propTypes = {
  name: PropTypes.string.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired
};
export default /*#__PURE__*/memo(FormGroupTab);